import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconClipboard2: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="clipboard-2, copy, list"><path d="M16.25 4.75H20.25V21.25H3.75V4.75H7.75M7.75 2.75H16.25V7.25H7.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconClipboard2;
